import { type IconName } from "icons";
import {
  SOCIAL_PLATFORMS as SHARED_SOCIAL_PLATFORMS,
  type SocialPlatformDefinition,
  type SocialPlatformId,
  getSocialPlatform,
} from "utils";

export type { SocialPlatformId } from "utils";
export {
  getSafeProfileHref,
  getSocialProfileUrl,
  getSocialUsernameFromUrl,
  getSocialPlatform,
} from "utils";

export interface SocialPlatform extends SocialPlatformDefinition {
  iconName: IconName;
}

const SOCIAL_PLATFORM_ICON_NAMES: Record<SocialPlatformId, IconName> = {
  instagram: "tabler-brand-instagram",
  youtube: "tabler-brand-youtube",
  tiktok: "tabler-brand-tiktok",
  email: "tabler-mail",
  x: "tabler-brand-x",
  facebook: "tabler-brand-facebook",
  linkedin: "tabler-brand-linkedin",
  threads: "tabler-brand-threads",
};

export const SOCIAL_PLATFORMS: SocialPlatform[] = SHARED_SOCIAL_PLATFORMS.map(
  (socialPlatform) => {
    return {
      ...socialPlatform,
      iconName: SOCIAL_PLATFORM_ICON_NAMES[socialPlatform.id],
    };
  },
);

export function getSocialIconName(
  platform: string | null | undefined,
): IconName {
  if (platform === "phone") {
    return "tabler-phone";
  }

  const socialPlatform = getSocialPlatform(platform);
  return socialPlatform
    ? SOCIAL_PLATFORM_ICON_NAMES[socialPlatform.id]
    : "tabler-link";
}
